module.exports = __webpack_public_path__ + "static/img/fluent-video-clip-24-regular.c1d45832.svg";